// extracted by mini-css-extract-plugin
module.exports = {"newCandidateId":"styles_newCandidateId__oNQ8g","newCandidateIdForm":"styles_newCandidateIdForm__3P4Bq","errorResponse":"styles_errorResponse__1G_IM"};